import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaClipboardList, FaFileAlt, FaHistory, FaSearch, FaPlusCircle } from "react-icons/fa";
import "./Dashboard.css";

const menuItems = [
  {
    icon: <FaClipboardList size={50} color="#dc3545" />, 
    title: "Thống kê", 
    description: "Xem tất cả các đơn xe bảo dưỡng - sửa chữa",
    component: 'thongkebdsc'
  },
  {
    icon: <FaFileAlt size={50} color="#007bff" />, 
    title: "Báo cáo tình trạng", 
    description: "Xem trạng thái và giá của những xe hiện đang ở trạm bảo dưỡng - sửa chữa",
    component: 'baoCaoTinhTrang'
  },
  {
    icon: <FaHistory size={50} color="#28a745" />, 
    title: "Lịch sử", 
    description: "Xem lịch sử các đơn bảo dưỡng - sửa chữa đã hoàn tất",
    component: 'lichSuBdSc'
  },
  {
    icon: <FaSearch size={50} color="#ffc107" />, 
    title: "Kiểm tra", 
    description: "Kiểm tra các xe kinh doanh hiện có còn đi được bao nhiêu km trước khi tới hạn bảo dưỡng",
    component: 'kiemTraXe'
  },
  {
    icon: <FaPlusCircle size={50} color="#17a2b8" />, 
    title: "Tạo đơn", 
    description: "Tạo đơn bảo dưỡng - sửa chữa",
    component: 'baoDuongSuaChua'
  }
];

const DashboardBdScComponent = ({ setComponentDuocChon }) => {
  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">BẢO DƯỠNG - SỬA CHỮA</h1>
      <Row className="g-4">
        {menuItems.map((item, index) => (
          <Col key={index} md={4} sm={6} xs={12}>
            <Card className="text-center shadow-sm p-3 h-100 d-flex flex-column dashboard-card">
              <Card.Body className="flex-grow-1 d-flex flex-column justify-content-between">
                <div>{item.icon}</div>
                <Card.Title className="mt-3" style={{ fontWeight: "bold" }}>{item.title}</Card.Title>
                <Card.Text>{item.description}</Card.Text>
                <Button 
                  variant="outline-danger"
                  onClick={() => setComponentDuocChon(item.component)}
                >
                  Xem chi tiết
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DashboardBdScComponent;
